import { adminHttpClient } from '../../../commons/adminHttpClient'
import { Moment } from 'moment'
import { PaymentMethod } from 'application/adminDashboard/companySettings/subscription/subscriptionDetails'

export interface RenewalUpdatePaymentInformationDTO {
  useSame: boolean
  recurlyToken?: string
  paymentMethod?: PaymentMethod
}

export const updateRenewalPaymentInformation = (payload: RenewalUpdatePaymentInformationDTO): Promise<any> => {
  return adminHttpClient.post('/AdminDashboard/RenewalPaymentInformation', payload)
}
